var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAkarIconsCircleCheckFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_12239)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99984 0.666656C3.94984 0.666656 0.666504 3.94999 0.666504 7.99999C0.666504 12.05 3.94984 15.3333 7.99984 15.3333C12.0498 15.3333 15.3332 12.05 15.3332 7.99999C15.3332 3.94999 12.0498 0.666656 7.99984 0.666656ZM11.1785 6.75999C11.237 6.69309 11.2816 6.61515 11.3096 6.53077C11.3375 6.44639 11.3483 6.35727 11.3414 6.26865C11.3344 6.18003 11.3097 6.0937 11.2689 6.01474C11.228 5.93578 11.1718 5.86579 11.1035 5.80888C11.0352 5.75198 10.9563 5.7093 10.8712 5.68336C10.7862 5.65743 10.6969 5.64877 10.6084 5.65788C10.52 5.66699 10.4343 5.69369 10.3563 5.73641C10.2784 5.77914 10.2098 5.83702 10.1545 5.90666L7.28784 9.34599L5.8045 7.86199C5.67877 7.74055 5.51037 7.67336 5.33557 7.67487C5.16077 7.67639 4.99356 7.74651 4.86996 7.87011C4.74635 7.99372 4.67624 8.16092 4.67472 8.33572C4.6732 8.51052 4.7404 8.67892 4.86184 8.80466L6.86184 10.8047C6.92734 10.8701 7.00577 10.9212 7.09211 10.9547C7.17846 10.9882 7.27084 11.0033 7.36335 10.9991C7.45586 10.9949 7.54649 10.9715 7.62945 10.9303C7.7124 10.8891 7.78587 10.8311 7.84517 10.76L11.1785 6.75999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_12239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsCircleCheckFill);
export default __webpack_public_path__ + "static/media/akar-icons_circle-check-fill.0af05ec10c428de7f3d6231c4f14df74.svg";
export { ForwardRef as ReactComponent };